var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload system-upload-file" },
    [
      _c(
        "el-upload",
        {
          ref: "upload_" + _vm.type,
          attrs: {
            action: "#",
            drag: "",
            multiple: "",
            "auto-upload": false,
            accept: _vm.acceptType,
            limit: _vm.availableSlots,
            disabled: _vm.uploading,
            "on-change": _vm.handleFile.bind(this, _vm.type),
            "on-remove": _vm.handleRemove.bind(this, _vm.type),
            "on-exceed": _vm.handleFileExceed.bind(this, _vm.type),
            "file-list": _vm.fileList,
          },
        },
        [
          _c("div", [
            _c("i", { staticClass: "el-icon-upload" }),
            _c("div", { staticClass: "el-upload__text" }, [
              _c("em", { staticStyle: { color: "#3855F1" } }, [
                _vm._v(
                  _vm._s(_vm.uploading ? "Uploading..." : "Click to upload")
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm.uploading
        ? _c(
            "div",
            { staticClass: "parse" },
            [
              _c("div", { staticClass: "upload-summary" }, [
                _vm._v(
                  "Uploading " +
                    _vm._s(_vm.uploadingFilesList.length) +
                    " file(s)..."
                ),
              ]),
              _vm._l(_vm.uploadingFilesList, function (item) {
                return _c(
                  "div",
                  { key: item.file.uid, staticClass: "file-upload-item" },
                  [
                    _c("span", { staticClass: "file-name" }, [
                      _vm._v(_vm._s(item.file.name)),
                    ]),
                    _c("span", { staticClass: "file-progress" }, [
                      _vm._v(_vm._s(item.progress) + "%"),
                    ]),
                    item.status === "success"
                      ? _c("span", { staticClass: "file-status success" }, [
                          _vm._v("✓"),
                        ])
                      : item.status === "failed"
                      ? _c("span", { staticClass: "file-status failed" }, [
                          _vm._v("✗"),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.uploading
        ? _c("Progress", { attrs: { progress: _vm.totalProgress } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }